module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.details && !_vm.editViews && !_vm.editPrinter && !_vm.addImage && !_vm.editAllergens) ? _c('main', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.currentItemEvent === 'edit' ? _vm.$lang.header.edit : _vm.$lang.header.add) + " " + _vm._s(_vm.$lang.header.item))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "vat",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0 mt-2 max-w",
    attrs: {
      "label": _vm.$lang.header.vat,
      "items": _vm.vatItems,
      "disabled": !this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0,
      "hide-details": ""
    },
    model: {
      value: (_vm.vatRate),
      callback: function($$v) {
        _vm.vatRate = $$v
      },
      expression: "vatRate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.views))]), _vm._v(" "), (_vm.selectedViews.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editViewsToggle
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editViewsToggle
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.selectedViews.length > 0) ? _c('div', {
    staticClass: "views mt-2 p-3"
  }, [_vm._l((_vm.views), function(view, index) {
    return (_vm.selectedViews.indexOf(view.viewId !== -1) && _vm.selectedViews[_vm.selectedViews.indexOf(view.viewId)] === view.viewId) ? [_c('p', {
      key: index
    }, [_vm._v(_vm._s(view.name[_vm.language]) + ", ")])] : _vm._e()
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.printerCategories))]), _vm._v(" "), (_vm.selectedPrinters.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editPrinterToggle()
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editPrinterToggle()
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.selectedPrinters.length > 0 || _vm.inheritSelectedPrinters.length > 0) ? _c('div', {
    staticClass: "views mt-2 p-3"
  }, [_vm._l((_vm.selectedPrinters), function(category, index) {
    return [_c('p', {
      key: index
    }, [_vm._v(_vm._s(category) + ", ")])]
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedPrinters), function(printer, index2) {
    return [_c('p', {
      key: 'I-' + index2,
      staticStyle: {
        "color": "blue !important"
      }
    }, [_vm._v(_vm._s(printer) + ", ")])]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.abbreviation))]), _vm._v(" "), (_vm.abbr === null) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Abbreviation', 'abbr')
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Abbreviation', 'abbr')
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.abbr !== null) ? _c('ul', _vm._l((_vm.languages), function(lang, index) {
    return (_vm.abbr && _vm.abbr.name[lang.value]) ? _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "d-inline-block light-text"
    }, [_vm._v("\n                [" + _vm._s(lang.text) + "]\n              ")]), _vm._v("\n                  " + _vm._s(_vm.abbr.name[lang.value]) + "\n                ")]) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.name))]), _vm._v(" "), (_vm.name === null) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Name', 'name')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Name', 'name')
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.name !== null) ? _c('ul', {
    staticClass: "mt-2"
  }, _vm._l((_vm.languages), function(lang, index) {
    return (_vm.name && _vm.name.name[lang.value]) ? _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "d-inline-block light-text"
    }, [_vm._v("\n                [" + _vm._s(lang.text) + "]\n              ")]), _vm._v("\n                  " + _vm._s(_vm.name.name[lang.value]) + "\n                ")]) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.description))]), _vm._v(" "), (_vm.desc === null) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Description', 'desc')
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Description', 'desc')
      }
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.desc !== null) ? _c('ul', {
    staticClass: "mt-2"
  }, _vm._l((_vm.languages), function(lang, index) {
    return (_vm.desc && _vm.desc.name[lang.value]) ? _c('li', {
      key: index
    }, [_c('span', {
      staticClass: "d-inline-block light-text"
    }, [_vm._v("\n                [" + _vm._s(lang.text) + "]\n              ")]), _vm._v("\n                  " + _vm._s(_vm.desc.name[lang.value]) + "\n                ")]) : _vm._e()
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.sizes))]), _vm._v(" "), (_vm.sizes.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Sizes', 'sizes')
      }
    }
  }, [_vm._v("\n                  add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Sizes', 'sizes')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.sizes.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.sizes)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.sizes), function(size, index) {
    return (_vm.sizes.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (size.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(size.name[lang.value]) + "\n                    " + _vm._s(size.price) + "\n                    "), (size.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  <" + _vm._s(_vm.$lang.labels.default) + ">\n                ")]) : _vm._e(), _vm._v(" "), (_vm.sizes.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('sizes', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('sizes', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedAttributes.sizes), function(size, index) {
    return (_vm.inheritSelectedAttributes.sizes !== 0) ? [_c('ul', {
      key: 'inhSize-' + index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (size.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "blue !important"
        }
      }, [_vm._v(_vm._s(size.name[lang.value]) + "\n                      " + _vm._s(size.price))])]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.options))]), _vm._v(" "), (_vm.options.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Options', 'options')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Options', 'options')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.options.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.options)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex",
    staticStyle: {
      "max-height": "25px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_vm._v(_vm._s(_vm.$lang.labels.quantityOfIncludedOptions) + ":")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "type": "number",
      "solo": "",
      "flat": "",
      "min": "0"
    },
    model: {
      value: (_vm.quantityOfIncludedOptions),
      callback: function($$v) {
        _vm.quantityOfIncludedOptions = $$v
      },
      expression: "quantityOfIncludedOptions"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return (_vm.options.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (option.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(option.name[lang.value]) + "\n                    " + _vm._s(option.price) + "\n                    "), _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                      (max: " + _vm._s(option.maxIncludedQuantity) + ")\n                    ")]), _vm._v(" "), (option.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                      <" + _vm._s(_vm.$lang.labels.default) + ">\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.options.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('options', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('options', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.allergens))]), _vm._v(" "), (_vm.selectedAllergens.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editAllergensToggle
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": _vm.editAllergensToggle
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), (_vm.selectedAllergens.length > 0) ? _c('div', {
    staticClass: "views mt-2 p-3"
  }, [_vm._l((_vm.allergens), function(allergen, index) {
    return (_vm.selectedAllergens.indexOf(allergen.allergenId !== -1) && _vm.selectedAllergens[_vm.selectedAllergens.indexOf(allergen.allergenId)] === allergen.allergenId) ? [_c('p', {
      key: index
    }, [_vm._v(_vm._s(allergen.name[_vm.language]) + ", ")])] : _vm._e()
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.styles))]), _vm._v(" "), (_vm.styles.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Styles', 'styles')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Styles', 'styles')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.styles.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.styles)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.styles), function(style, index) {
    return (_vm.styles.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (style.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(style.name[lang.value]) + "\n                    "), (style.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  <" + _vm._s(_vm.$lang.labels.default) + ">\n                ")]) : _vm._e(), _vm._v(" "), (_vm.styles.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('styles', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('styles', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedAttributes.styles), function(style, index) {
    return (_vm.inheritSelectedAttributes.styles !== 0) ? [_c('ul', {
      key: 'inhStyle-' + index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (style.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "blue !important"
        }
      }, [_vm._v(_vm._s(style.name[lang.value]) + "\n                      " + _vm._s(style.price))])]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "wrap": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.variants))]), _vm._v(" "), (_vm.variants.length === 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openDetails('Variants', 'variants')
      }
    }
  }, [_vm._v("add\n                ")]) : _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.editItem('Variants', 'variants')
      }
    }
  }, [_vm._v("edit")]), _vm._v(" "), (_vm.variants.length > 0) ? _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.removeDefaults(_vm.variants)
      }
    }
  }, [_vm._v("\n                  turned_in_not\n                ")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.variants), function(variant, index) {
    return (_vm.variants.length !== 0) ? [_c('ul', {
      key: index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (variant.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v("\n                    " + _vm._s(variant.name[lang.value]) + "\n                    " + _vm._s(variant.price) + "\n                    "), (variant.isDefault) ? _c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  <" + _vm._s(_vm.$lang.labels.default) + ">\n                ")]) : _vm._e(), _vm._v(" "), (_vm.variants.length > 1) ? _c('span', {
        staticClass: "arrow_to_move"
      }, [_c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemUp('variants', index)
          }
        }
      }, [_vm._v("keyboard_arrow_up")]), _vm._v(" "), _c('i', {
        staticClass: "material-icons pointerClass",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.moveItemDown('variants', index)
          }
        }
      }, [_vm._v("keyboard_arrow_down")])]) : _vm._e()]) : _vm._e()
    }), 0)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.inheritSelectedAttributes.variants), function(variant, index) {
    return (_vm.inheritSelectedAttributes.variants !== 0) ? [_c('ul', {
      key: 'inhStyle-' + index,
      staticClass: "mt-2 pt-2 underline"
    }, _vm._l((_vm.languages), function(lang, langIndex) {
      return (variant.name[lang.value]) ? _c('li', {
        key: langIndex
      }, [_c('span', {
        staticClass: "d-inline-block light-text"
      }, [_vm._v("\n                  [" + _vm._s(lang.text) + "]\n                ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "color": "blue !important"
        }
      }, [_vm._v(_vm._s(variant.name[lang.value]) + "\n                      " + _vm._s(variant.price))])]) : _vm._e()
    }), 0)] : _vm._e()
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "checkbox-wrap",
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.$lang.header.settings))]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.labelPrint,
      "hide-details": ""
    },
    model: {
      value: (_vm.labelPrint),
      callback: function($$v) {
        _vm.labelPrint = $$v
      },
      expression: "labelPrint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.askDetails,
      "hide-details": ""
    },
    model: {
      value: (_vm.askDetails),
      callback: function($$v) {
        _vm.askDetails = $$v
      },
      expression: "askDetails"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.vatPrint,
      "hide-details": ""
    },
    model: {
      value: (_vm.vatPrint),
      callback: function($$v) {
        _vm.vatPrint = $$v
      },
      expression: "vatPrint"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.noDiscount,
      "hide-details": ""
    },
    model: {
      value: (_vm.noDiscount),
      callback: function($$v) {
        _vm.noDiscount = $$v
      },
      expression: "noDiscount"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.addsGalaxyCardBalance,
      "hide-details": ""
    },
    model: {
      value: (_vm.galaxyCardBalance),
      callback: function($$v) {
        _vm.galaxyCardBalance = $$v
      },
      expression: "galaxyCardBalance"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.color))]), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-4",
    attrs: {
      "align-center": "",
      "row": ""
    }
  }, [(_vm.color) ? _c('span', {
    staticClass: "color-preview mr-3",
    style: ({
      'background-color': _vm.color
    })
  }) : _vm._e(), _vm._v(" "), _c('v-combobox', {
    staticClass: "min-w",
    attrs: {
      "label": _vm.$lang.header.color,
      "items": _vm.colors,
      "search-input": _vm.color,
      "hide-details": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.color = $event
      },
      "update:search-input": function($event) {
        _vm.color = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return _c('v-list-tile-content', {}, [_c('v-layout', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "row": "",
            "align-center": "",
            "justify-center": ""
          }
        }, [_c('div', {
          staticClass: "shrink mr-2"
        }, [_vm._v(_vm._s(data.item))]), _vm._v(" "), _c('v-flex', {
          staticClass: "list-color-preview",
          style: ({
            'background-color': data.item
          }),
          attrs: {
            "grow": ""
          }
        })], 1)], 1)
      }
    }], null, false, 2874364866),
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.taxCategory))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "row": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.taxCategories
    },
    nativeOn: {
      "input": function($event) {
        return (function (e) { return _vm.taxCategory = e.target.value; })($event)
      }
    },
    model: {
      value: (_vm.taxCategory),
      callback: function($$v) {
        _vm.taxCategory = $$v
      },
      expression: "taxCategory"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.courseNo))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "6",
      "rules": [function (v) { return v > 0 && v < 7 || 'Error'; }],
      "label": _vm.$lang.header.courseNo
    },
    model: {
      value: (_vm.courseNo),
      callback: function($$v) {
        _vm.courseNo = $$v
      },
      expression: "courseNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": "",
      "align-start": "",
      "py-2": ""
    }
  }, [_c('h3', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.images))]), _vm._v(" "), _c('v-icon', {
    staticClass: "my-0 d-inline-block",
    on: {
      "click": function($event) {
        return _vm.openAddImage()
      }
    }
  }, [_vm._v("\n              add\n            ")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "45%",
      "overflow-y": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.images.length > 0) ? _c('v-list', [_vm._l((_vm.filteredAddedImages), function(image, index) {
    return [_c('v-list-tile', {
      key: image.id,
      attrs: {
        "dense": "true"
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(image.label))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }, [_vm._v(_vm._s(image.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('div', {
      staticClass: "my-0 d-inline-block"
    }, [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.preview(image.base64Image)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$lang.actions.preview) + "\n                        ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "dark": "",
        "icon": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImg(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])], 1), _vm._v(" "), (index + 1 < _vm.items.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "45%"
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.previewImage !== '') ? _c('v-img', {
    staticStyle: {
      "max-height": "200px !important"
    },
    attrs: {
      "src": _vm.previewImage,
      "contain": ""
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-start": "",
      "align-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.submitItem(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.copy))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.paste()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.paste))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-1 ml-5",
    attrs: {
      "color": "blue",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.plusOneFunct()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.importFromParent))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitItem()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.details) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.edit) + " " + _vm._s(_vm.currentLabel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeEdit()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))]) : _vm._e(), _vm._v(" "), (_vm.hasMultiple) ? _c('div', _vm._l((_vm.currentEdit), function(edit, index) {
    return _c('div', {
      key: index,
      staticClass: "single-item mb-3"
    }, [_c('div', {
      staticClass: "v-table__overflow"
    }, [_c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.language))]), _vm._v(" "), _c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.name))]), _vm._v(" "), _c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.default))]), _vm._v(" "), _c('th', {
      staticClass: "column text-xs-left",
      attrs: {
        "role": "columnheader",
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm.$lang.header.actions))])])]), _vm._v(" "), _c('tbody', _vm._l((edit.names), function(item, index2) {
      return _c('tr', {
        key: index2
      }, [_c('td', [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
        attrs: {
          "type": "text",
          "value": item.name
        },
        on: {
          "blur": function($event) {
            item.name = item.name.trim()
          }
        },
        model: {
          value: (item.name),
          callback: function($$v) {
            _vm.$set(item, "name", $$v)
          },
          expression: "item.name"
        }
      })], 1), _vm._v(" "), _c('td', [(_vm.currentEdit[index].isDefault && _vm.currentLabel !== 'Options') ? _c('p', {
        staticClass: "default-item"
      }, [_vm._v(_vm._s(_vm.$lang.actions.yes))]) : _c('v-checkbox', {
        staticClass: "pt-3",
        attrs: {
          "color": "primary",
          "label": _vm.$lang.labels.isDefault
        },
        model: {
          value: (_vm.currentEdit[index].isDefault),
          callback: function($$v) {
            _vm.$set(_vm.currentEdit[index], "isDefault", $$v)
          },
          expression: "currentEdit[index].isDefault"
        }
      })], 1), _vm._v(" "), _c('td', [(!_vm.currentEdit[index].isDefault && _vm.currentLabel !== 'Options') ? _c('v-btn', {
        attrs: {
          "color": "primary",
          "fab": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            return _vm.setEditToDefault(index, item)
          }
        }
      }, [_c('v-icon', [_vm._v("turned_in")])], 1) : _vm._e(), _vm._v(" "), (_vm.currentEdit[index].isDefault && _vm.currentLabel !== 'Options') ? _c('v-btn', {
        attrs: {
          "fab": "",
          "small": ""
        }
      }, [_c('v-icon', [_vm._v("turned_in_not")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
        attrs: {
          "fab": "",
          "small": "",
          "color": "error"
        },
        on: {
          "click": function($event) {
            return _vm.removeLang(index, index2)
          }
        }
      }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
    }), 0)])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "justify-space-between": "",
        "align-center": ""
      }
    }, [(edit.languages.length > 0) ? _c('div', {
      staticClass: "text-xs-center"
    }, [_c('v-menu', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "slot": "activator",
        "outline": "",
        "flat": "",
        "type": "button"
      },
      slot: "activator"
    }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.addlanguage) + "\n                  "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((edit.languages), function(lang, langIndex) {
      return _c('v-list-tile', {
        key: langIndex,
        staticClass: "dropdown-item",
        on: {
          "click": function($event) {
            return _vm.addEditLang(lang.value, langIndex, index)
          }
        }
      }, [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(lang.text) + "\n                    ")])], 1)
    }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeEdit(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.deleteitem) + "\n            ")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [(_vm.hasPrice) ? _c('v-flex', {
      attrs: {
        "xs2": "",
        "pr-2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "label": "Price"
      },
      model: {
        value: (edit.price),
        callback: function($$v) {
          _vm.$set(edit, "price", $$v)
        },
        expression: "edit.price"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.currentLabel === 'Options') ? _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-2": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.quantityOfIncludedOptions,
        "rules": [function (value) { return value <= _vm.quantityOfIncludedOptions || 'Must not be higher than Quantity Of Included Options!'; }],
        "label": ((_vm.$lang.labels.includedQuantity) + " (max " + _vm.quantityOfIncludedOptions + ")")
      },
      model: {
        value: (edit.maxIncludedQuantity),
        callback: function($$v) {
          _vm.$set(edit, "maxIncludedQuantity", $$v)
        },
        expression: "edit.maxIncludedQuantity"
      }
    })], 1) : _vm._e()], 1)], 1)
  }), 0) : _c('div', {
    staticClass: "v-table__overflow"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.language))]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.name))]), _vm._v(" "), _c('th', {
    staticClass: "column text-xs-left",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.header.actions))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentEdit[0].names), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.language))]), _vm._v(" "), _c('td', [_c('v-text-field', {
      attrs: {
        "type": "text",
        "value": item.name
      },
      on: {
        "blur": function($event) {
          item.name = item.name.trim()
        }
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "color": "error",
        "fab": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeLang(0, index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [(_vm.hasMultiple) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.addEdit()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (!_vm.hasMultiple && _vm.currentEdit[0].languages.length > 0) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-menu', [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "outline": "",
      "flat": "",
      "type": "button"
    },
    slot: "activator"
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.actions.addlanguage) + "\n              "), _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.currentEdit[0].languages), function(lang, index) {
    return _c('v-list-tile', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addEditLang(lang.value, index)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(lang.text) + "\n                ")])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editViews) ? _c('div', {
    staticClass: "description"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.editViews))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeViews()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.catalogViews), function(view, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": view.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (view.selected),
        callback: function($$v) {
          _vm.$set(view, "selected", $$v)
        },
        expression: "view.selected"
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitViews()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editAllergens) ? _c('div', {
    staticClass: "description"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.editAllergens))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeAllergens()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.catalogAllergens), function(allergen, index) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": allergen.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (allergen.selected),
        callback: function($$v) {
          _vm.$set(allergen, "selected", $$v)
        },
        expression: "allergen.selected"
      }
    })], 1)]
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitAllergens()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.editPrinter) ? _c('div', {
    staticClass: "description"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.editPrinterCategories))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "small": "",
      "fab": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closePrinter()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.catalogPrinters), function(printerCategory, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "disabled": index === 0,
        "label": printerCategory.name
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (printerCategory.selected),
        callback: function($$v) {
          _vm.$set(printerCategory, "selected", $$v)
        },
        expression: "printerCategory.selected"
      }
    })
  }), 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitPrinters()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.addImage) ? _c('div', {
    staticClass: "description"
  }, [(_vm.errImage) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.errImage))]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.actions.addImage1))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.addImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.labels,
      "label": _vm.$lang.labels.choseLabelToAddImage
    },
    on: {
      "input": function($event) {
        _vm.selectedImage = {}
      }
    },
    model: {
      value: (_vm.selectedLabel),
      callback: function($$v) {
        _vm.selectedLabel = $$v
      },
      expression: "selectedLabel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "loading": _vm.loading,
      "label": _vm.selectedLabel === '' ? _vm.$lang.labels.selectLabelFirst : _vm.$lang.labels.selectImage,
      "items": _vm.filteredImages,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.fetchImageById()
      }
    },
    model: {
      value: (_vm.selectedImageId),
      callback: function($$v) {
        _vm.selectedImageId = $$v
      },
      expression: "selectedImageId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "xs12": "",
      "sm4": "",
      "pa-2": ""
    }
  }, [(_vm.loadingPreview) ? _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedImage.base64Image) ? _c('v-img', {
    staticStyle: {
      "max-height": "180px  !important"
    },
    attrs: {
      "src": _vm.selectedImage.base64Image,
      "contain": ""
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "disabled": !_vm.selectedImage.base64Image,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitAddImage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dce9e85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SingleItem.vue
// module id = 571
// module chunks = 14